import { useEffect, useRef, useCallback } from "react";
import Lenis from "lenis";
import "@/App.css";
import Hero from "@/components/landing/Hero";
import Wiedererkennung from "@/components/landing/Wiedererkennung";
import Schwerfallen from "@/components/landing/Schwerfallen";
import WarumHypno from "@/components/landing/WarumHypno";
import KoerperGehirn from "@/components/landing/KoerperGehirn";
import Unterschied from "@/components/landing/Unterschied";
import DeineMinuten from "@/components/landing/DeineMinuten";
import MarqueeBand from "@/components/landing/MarqueeBand";
import Begleitung from "@/components/landing/Begleitung";
import WarumLive from "@/components/landing/WarumLive";
import ClosingCta from "@/components/landing/ClosingCta";
import Booking from "@/components/landing/Booking";
import StickyCta from "@/components/landing/StickyCta";
import Admin from "@/pages/Admin";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function Landing({ onBook }) {
  return (
    <div className="App bg-cream text-ink overflow-x-clip">
      <div className="grain-overlay" aria-hidden="true" />
      <Hero onBook={onBook} />
      <Wiedererkennung />
      <Schwerfallen />
      <WarumHypno />
      <KoerperGehirn />
      <Unterschied />
      <DeineMinuten onBook={onBook} />
      <MarqueeBand />
      <Begleitung />
      <WarumLive />
      <ClosingCta onBook={onBook} />
      <Booking />
      <StickyCta onBook={onBook} />
    </div>
  );
}

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.35, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollToBooking = useCallback(() => {
    const target = document.getElementById("buchen");
    if (!target) return;
    try {
      if (lenisRef.current) {
        lenisRef.current.scrollTo("#buchen", { duration: 1.8 });
        return;
      }
    } catch {
      // Lenis im Fehlerfall umgehen
    }
    target.scrollIntoView({ behavior: "smooth" });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing onBook={scrollToBooking} />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
